import moment from 'moment'
import Vue from 'vue'
export default {
    install: (Vue, options) => {
        const pdf = {
            name: 'pdf',
            toCurrency(value) {
                if (typeof value !== "number") {
                    return value;
                } else {
                    if (value < 0) {
                        value = -value;
                    }
                }
                return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

            },
            getBase64ImageFromURL(url) {
                return new Promise((resolve, reject) => {
                    var img = new Image();
                    img.setAttribute("crossOrigin", "anonymous");

                    img.onload = () => {
                        var canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;

                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);

                        var dataURL = canvas.toDataURL("image/png");

                        resolve(dataURL);
                    };

                    img.onerror = error => {
                        reject(error);
                    };

                    img.src = url;
                });
            },
            headerP({quotation, marginRight = 30}) {
                return {
                    stack: [
                        {
                            marginRight : marginRight,
                            text: 'Quote No : ' + quotation.QuoteNo,
                            bold: true,
                            alignment: 'right',
                            marginTop: 10
                        },
                        {
                            marginRight : marginRight,
                            text: 'Handler Code: ' + quotation.HandlerCodeForPreview,
                            alignment: 'right',
                        },
                        {
                            marginRight : marginRight,
                            text: 'Currency: USD',
                            alignment: 'right',

                        }
                    ]
                }
            },
            headerL({logo}) {
                let header = [];
                header.push(
                    {
                        text: '',
                        marginTop: 7,
                    }
                );

                if(logo){
                    header.push(
                        {
                            image: logo,
                            width: 100,
                            alignment: 'center',
                        },
                    );
                }
                return header;
            },
            headerLAsset({logo}) {
                let header = [];
                header.push(
                    {
                        text: '',
                        marginTop: 7,
                    }
                );

                if(logo){
                    header.push(
                        {
                            image: logo,
                            width: 150,
                            alignment: 'center',
                        },
                    );
                }
                return header;
            },
            headerPolicyP({quotation}) {
                return [
                    {
                        text: 'Policy No : ' + quotation.policy_no,
                        bold: true,
                        alignment: 'right',
                        marginRight: 30,
                        marginTop: 20
                    },
                   {
                        text: 'Handler Code: ' ,
                        alignment: 'right',
                        marginRight: 30
                    },
                    {
                        text: 'Currency: USD',
                        alignment: 'right',
                        marginRight: 30
                    }

                ];
            },

            placeSigning(quotation){
                let body = [];

                body.push(
                    {
                        text: '', margin: [20, 20]
                    }
                );
                body.push(
                    {
                        columns : [
                            {
                                stack: [
                                    {text: "Prepared By:", alignment: 'center'},
                                    {text: '', margin: [20, 20]},
                                    {text: quotation.PreparedBy, alignment: 'center'},
                                    {text: moment(quotation.IssuedDate).format('DD/MMM/YYYY'), alignment: 'center'},
                                ]
                            },
                            {
                                stack: [
                                    {text: "Checked By:", alignment: 'center'},
                                    {text: '', margin: [20, 20]},
                                    {text: quotation.Checked, alignment: 'center'},
                                    {text: moment(quotation.IssuedDate).format('DD/MMM/YYYY'), alignment: 'center'},
                                ]
                            },
                            {
                                stack: [
                                    {text: "Approved By:", alignment: 'center'},
                                    {text: '', margin: [20, 20]},
                                    {text: quotation.Approved, alignment: 'center'},
                                    {text: moment(quotation.IssuedDate).format('DD/MMM/YYYY'), alignment: 'center'},
                                ]
                            },
                        ]
                    }
                );
                return body;

            },
            footerP({currentPage, pageCount, quotation}) {

                let footer = [];
                if(quotation.PreparedBy){
                    footer.push(
                        {
                            text: 'Prepared By: ' + quotation.PreparedBy,
                            marginLeft: 45
                        }
                    )
                }

                return {
                    columns: [
                        {
                            stack: footer
                        },
                        {
                            text: 'Page ' + currentPage.toString() + ' of ' + pageCount,
                            alignment: 'right',
                            marginRight: 30
                        },
                    ]
                };
            },
            footerL({currentPage, pageCount}) {
                return {
                    columns: [
                        {
                            text: '',
                            marginLeft: 45
                        },
                        {
                            text: 'Page' + currentPage.toString() + ' of ' + pageCount,
                            alignment: 'right',
                            marginRight: 30
                        },
                    ]
                };
            },
            headTitle({title}) {
                let upTitle = title;
                return [
                    {
                        layout: 'noBorders',
                        table: {
                            widths: ['*'],
                            body: [[{text: upTitle.toUpperCase(), style: 'title'}]]
                        },
                    },
                    {text: '', margin: [5, 5]}
                ];
            },
            headTitleRI({title}) {
                return [
                    {
                        layout: 'noBorders',
                        table: {
                            widths: ['*'],
                            body: [[{text: title.toUpperCase(), style: 'title'}]]
                        },
                    },
                    {text: '', margin: [5, 5]}
                ];
            },

            headTitleLocation({title}) {
                let upTitle = title + 'ATTACHMENT OF LOCATION OF RISK';
                return [
                    {
                        layout: 'noBorders',
                        table: {
                            widths: ['*'],
                            body: [[{text: upTitle.toUpperCase(), style: 'title'}]]
                        },
                    },
                    {text: '', margin: [5, 5]}
                ];
            },

            headPolicyTitle({title}) {
                let upTitle = title + ' POLICY SCHEDULE';
                return [
                    {
                        layout: 'noBorders',
                        table: {
                            widths: ['*'],
                            body: [[{text: upTitle.toUpperCase(), style: 'title'}]]
                        },
                    },
                    {text: '', margin: [5, 5]}
                ];
            },
            title({title, visible = true}) {
                if (visible) {
                    return [
                        {
                            layout: 'noBorders',
                            table: {
                                widths: ['*'],
                                body: [[{text: title,fontSize:12, style: 'subTitleHandOver', color:"#ffffff"}]]
                            },
                        },
                        {text: '', margin: [0, 2]}
                    ];
                } else {
                    return [];
                }
            },
            labelValue({label, value, show = false, width = 100, size, height = 1.1,paddingLeft = 0, alignment = 'left'}) {
                if (value) {
                    return [
                        {
                            columns: [
                                {
                                    'alignment': alignment,
                                    width: alignment !== 'left' ? '*' : width,
                                    text: label,
                                    bold: true,
                                    fontSize: size,
                                    lineHeight: height,
                                    marginRight: 5,
                                    paddingLeft: paddingLeft,

                                },
                                {
                                    'alignment': alignment,
                                    width: alignment !== 'left' ? width : '*',
                                    text: ': ' + value,
                                    fontSize: size,
                                    lineHeight: height,
                                }
                            ],
                        },
                    ];
                } else  if (show) {
                    return [
                        {
                            columns: [
                                {
                                    width: width,
                                    text: label,
                                    bold: true,
                                    fontSize: size,
                                    lineHeight: height
                                },
                                {
                                    width: '*',
                                    text: ': ',
                                    fontSize: size,
                                    lineHeight: height
                                }
                            ],
                        }
                    ];
                }else{
                    return []
                }
            },
            labelValuePPI({label, value, show = false, width = 100, size, height = 1.1,paddingLeft = 0, alignment = 'left'}) {
                if (value) {
                    return [
                        {
                            columns: [
                                {
                                    'alignment': alignment,
                                    width: alignment !== 'left' ? '*' : width,
                                    text: label,
                                    bold: true,
                                    fontSize: size,
                                    lineHeight: height,
                                    marginRight: 5,
                                    paddingLeft: paddingLeft,

                                },
                                {
                                    'alignment': alignment,
                                    width: alignment !== 'left' ? width : '*',
                                    text: ' ' + value,
                                    fontSize: size,
                                    lineHeight: height,
                                }
                            ],
                        },
                    ];
                } else  if (show) {
                    return [
                        {
                            columns: [
                                {
                                    width: width,
                                    text: label,
                                    bold: true,
                                    fontSize: size,
                                    lineHeight: height
                                },
                                {
                                    width: '*',
                                    text: ' ',
                                    fontSize: size,
                                    lineHeight: height
                                }
                            ],
                        }
                    ];
                }else{
                    return []
                }
            },
            labelValueKhmer({label, value, width = 100, size = 8}) {
                if (value) {
                    return [
                        {
                            columns: [
                                {
                                    width: width,
                                    text: label, bold: true,
                                    fontSize: size,
                                    font: 'Hanuman',
                                },
                                {
                                    width: '*',
                                    text: ': ' + value,
                                    fontSize: size,
                                    font: 'Hanuman',
                                }
                            ],
                        },
                    ];
                } else {
                    return [];
                }
            },
            checkBox({label, image,bold = true}) {
                return [
                    {
                        image: image,
                        width: 10,
                    },
                    {
                        text: label,
                        bold: bold,
                        width: 'auto',
                        marginLeft: 5,
                        marginRight: 15
                    },
                ];
            },

            column({data, width = []}) {
                let result = [];
                if (data.length > 0) {
                    data.forEach((v, i) => {
                        if (width.length === 0) {
                            width.push('auto')
                        }
                        result.push({
                                width: width[i],
                                columns: v
                            },
                            {text: '', margin: [2, 0]}
                        )
                    });

                    return [
                        {
                            columns: result,
                        },
                    ];
                } else {
                    return [];
                }
            },
            textBold({value, visible = '',size,decoration = '',height= 1,marginLeft = 0}){
                if(!visible) {
                    return [
                        {
                            width: 'auto',
                            text: value, bold: true,
                            fontSize: size,
                            decoration : decoration,
                            lineHeight: height,
                            marginLeft : marginLeft,
                        }
                    ]
                }else {
                    return []
                }
            },
            textNormal({value, visible = '',size,decoration = '',height= 1.1,marginLeft = 10}){
                if(!visible) {
                    return [
                        {
                            marginLeft: marginLeft,
                            text: value, fontSize: size,decoration : decoration,lineHeight: height,
                        }
                    ]
                }else {
                    return []
                }
            },

            line() {
                return [
                    {text: '', margin: [0, 5]},
                    {canvas: [{type: 'line', x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 0.5}]},
                    {text: '', margin: [0, 5]}
                ];
            },
            lineBold() {
                return [
                    {text: '', margin: [0, 5]},
                    {canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1}]},
                    {text: '', margin: [0, 5]}
                ];
            },

            signature({quotation}) {
                return [
                    {
                        columns: [
                            {
                                width: 'auto',
                                text: 'Issued Date',
                                bold: true,
                            },
                            {
                                width: 'auto',
                                text: quotation.IssuedDate?moment(quotation.IssuedDate).format('DD/MMM/YYYY'):'',
                                marginLeft: 5
                            },
                            {
                                width: '*',
                                text: ''
                            },
                            {
                                width: 'auto',
                                text: 'Valid Until',
                                bold: true,
                            },
                            {
                                width: 'auto',
                                text: quotation.Validity?moment(quotation.Validity).format('DD/MMM/YYYY'):'',
                                marginLeft: 5
                            }
                        ]
                    },
                    {
                        canvas:
                            [
                                {
                                    type: 'line',
                                    x1: 0, y1: 0,
                                    x2: 520, y2: 0,
                                    lineWidth: 2
                                },
                            ]
                    },
                    {text: '', margin: [0, 5]},
                    {
                        columns: [
                            {
                                width: 200,
                                text: 'For and on behalf of PPI',
                                bold: true,
                                alignment: 'center'
                            },
                            {
                                width: '*',
                                text: ''
                            },
                            {
                                width: 200,
                                text: "Insured's Acceptance",
                                bold: true,
                                alignment: 'center'
                            }
                        ]
                    },
                    {
                        columns: [
                            {
                                width: 200,
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {text: '', margin: [0, 10]},
                                                    {
                                                        columns: [
                                                            {
                                                                width: 130,
                                                                canvas: [
                                                                    {
                                                                        type: 'line',
                                                                        x1: 0, y1: 15,
                                                                        x2: 130, y2: 15,
                                                                        lineWidth: 0.5
                                                                    },
                                                                ]
                                                            },
                                                            {
                                                                text: '(dd/mmm/yyyy)'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        canvas: [
                                                            {
                                                                type: 'line',
                                                                x1: 0, y1: 96,
                                                                x2: 200, y2: 96,
                                                                lineWidth: 0.5
                                                            },
                                                        ]
                                                    },
                                                    {text: '', margin: [0, 2]},
                                                    {
                                                        text: 'Authorized Signatory (Company Stamp if applicable)',
                                                        fontSize: 7.5
                                                    },
                                                ]
                                            }
                                        ]
                                    ]
                                }
                            },
                            {
                                width: '*',
                                text: ''
                            },
                            {
                                width: 200,
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {
                                                        text: 'We hereby accept the terms and conditions of this quotation. Please issue the policy to incept from',
                                                        fontSize: 7,
                                                        marginBottom: 2
                                                    },
                                                    {
                                                        columns: [
                                                            {
                                                                width: 130,
                                                                height: 150,
                                                                canvas: [
                                                                    {
                                                                        type: 'line',
                                                                        x1: 0, y1: 10,
                                                                        x2: 130, y2: 10,
                                                                        lineWidth: 0.5
                                                                    },
                                                                ]
                                                            },
                                                            {
                                                                text: '(dd/mmm/yyyy)'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        canvas: [
                                                            {
                                                                type: 'line',
                                                                x1: 0, y1: 75,
                                                                x2: 190, y2: 75,
                                                                lineWidth: 0.5
                                                            },
                                                        ]
                                                    },
                                                    {text: '', margin: [0, 2]},
                                                    {
                                                        text: 'Authorized Signatory (Company Stamp if applicable)',
                                                        fontSize: 7.5
                                                    },
                                                    {text: '', margin: [0, 2]},
                                                    {
                                                        text: 'Date:',
                                                        fontSize: 7.5
                                                    },
                                                ]
                                            }
                                        ]
                                    ]
                                }
                            }
                        ]
                    }
                ]
            },

            signatureEbuy({marginRight}) {
                return [
                    {text: '', margin: [0, 5]},
                    {
                        columns: [
                            {
                                width: '*',
                                text: '',
                            },
                            {
                                width: 200,
                                text: 'For and on behalf of PPI',
                                bold: true,
                                alignment: 'center'
                            },
                        ]
                    },
                    {
                        marginRight : marginRight,
                        columns: [
                            {
                                width: '*',
                                text: '',
                            },
                            {
                                width: 200,

                                table: {
                                    widths: ['*'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {text: '', margin: [0, 3]},
                                                    {
                                                        columns: [
                                                            {
                                                                width: 130,
                                                                canvas: [
                                                                    {
                                                                        type: 'line',
                                                                        x1: 0, y1: 15,
                                                                        x2: 130, y2: 15,
                                                                        lineWidth: 0.5
                                                                    },
                                                                ]
                                                            },
                                                            {
                                                                text: '(dd/mmm/yyyy)'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        canvas: [
                                                            {
                                                                type: 'line',
                                                                x1: 0, y1: 96,
                                                                x2: 200, y2: 96,
                                                                lineWidth: 0.5
                                                            },
                                                        ]
                                                    },
                                                    {text: '', margin: [0, 2]},
                                                    {
                                                        text: 'Authorized Signatory (Company Stamp if applicable)',
                                                        fontSize: 7.5
                                                    },
                                                ]
                                            }
                                        ]
                                    ]
                                }
                            },
                        ]
                    }
                ]
            },

            computerGeneratedSignatureAssetHandOver() {
                return [
                    {text: '', margin: [0, 15]},
                    {
                        columns: [
                            {
                                width: 200,
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {text: '', margin: [0, 40]},
                                                    {
                                                        canvas: [
                                                            {
                                                                type: 'line',
                                                                x1: 0, y1: 10,
                                                                x2: 190, y2: 10,
                                                                lineWidth: 0.5
                                                            },
                                                        ]
                                                    },
                                                    {text: 'Giver:', margin: [0, 7]},
                                                ]
                                            }
                                        ]
                                    ]
                                }
                            },
                            {text: '', margin: [0, 50]},
                            {
                                width: 200,
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {text: '', margin: [0, 40]},
                                                    {
                                                        canvas: [
                                                            {
                                                                type: 'line',
                                                                x1: 0, y1: 10,
                                                                x2: 190, y2: 10,
                                                                lineWidth: 0.5
                                                            },
                                                        ]
                                                    },
                                                    {text: 'Receiver:', margin: [0, 7]},
                                                ]
                                            }
                                        ]
                                    ]
                                }
                            }
                        ]
                    }
                ]
            },
            computerGeneratedSignature({quotation}) {
                return [
                    {
                        columns: [
                            {
                                width: 'auto',
                                text: 'Issued Date',
                                bold: true,
                            },
                            {
                                width: 'auto',
                                text:quotation.IssuedDate? moment(quotation.IssuedDate).format('DD/MMM/YYYY'):'',
                                marginLeft: 5
                            },
                            {
                                width: '*',
                                text: ''
                            },
                            {
                                width: 'auto',
                                text: 'Valid Until',
                                bold: true,
                            },
                            {
                                width: 'auto',
                                text:quotation.Validity? moment(quotation.Validity).format('DD/MMM/YYYY'):'',
                                marginLeft: 5
                            }
                        ]
                    },
                    {
                        canvas:
                            [
                                {
                                    type: 'line',
                                    x1: 0, y1: 0,
                                    x2: 520, y2: 0,
                                    lineWidth: 2
                                },
                            ]
                    },
                    {text: '', margin: [0, 5]},
                    {
                        columns: [
                            {
                                width: 200,
                                text: '',
                                bold: true,
                                alignment: 'center'
                            },
                            {
                                width: '*',
                                text: ''
                            },
                            {
                                width: 200,
                                text: "Insured's Acceptance",
                                bold: true,
                                alignment: 'center'
                            }
                        ]
                    },
                    {
                        columns: [
                            {
                                width: 220,
                                text: "\t This is a computer generated document, and it does not require signature." +
                                    "This document shall not be invalidated solely on the ground that it is not signed.",
                                fontSize: 7,
                                marginBottom: 2
                            },
                            {
                                width: '*',
                                text: ''
                            },
                            {
                                width: 200,
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {
                                                        text: 'We hereby accept the terms and conditions of this quotation. Please issue the policy to incept from',
                                                        fontSize: 7,
                                                        marginBottom: 2
                                                    },
                                                    {
                                                        columns: [
                                                            {
                                                                width: 130,
                                                                height: 150,
                                                                canvas: [
                                                                    {
                                                                        type: 'line',
                                                                        x1: 0, y1: 10,
                                                                        x2: 130, y2: 10,
                                                                        lineWidth: 0.5
                                                                    },
                                                                ]
                                                            },
                                                            {
                                                                text: '(dd/mmm/yyyy)'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        canvas: [
                                                            {
                                                                type: 'line',
                                                                x1: 0, y1: 75,
                                                                x2: 190, y2: 75,
                                                                lineWidth: 0.5
                                                            },
                                                        ]
                                                    },
                                                    {text: '', margin: [0, 2]},
                                                    {
                                                        text: 'Authorized Signatory (Company Stamp if applicable)',
                                                        fontSize: 7.5
                                                    },
                                                    {text: '', margin: [0, 2]},
                                                    {
                                                        text: 'Date:',
                                                        fontSize: 7.5
                                                    },
                                                ]
                                            }
                                        ]
                                    ]
                                }
                            }
                        ]
                    }
                ]
            },
            signaturePolicy() {
                return [
                    {
                        canvas:
                            [
                                {
                                    type: 'line',
                                    x1: 0, y1: 0,
                                    x2: 535, y2: 0,
                                    lineWidth: 2
                                },
                            ]
                    },
                    {text: '', margin: [0, 5]},
                    {
                        columns: [
                            {
                                width: 200,
                                text: 'For and on behalf of PPI',
                                bold: true,
                                alignment: 'center'
                            },
                        ]
                    },
                    {
                        columns: [
                            {
                                width: 200,
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {text: '', margin: [0, 10]},
                                                    {
                                                        columns: [
                                                            {
                                                                width: 130,
                                                                canvas: [
                                                                    {
                                                                        type: 'line',
                                                                        x1: 0, y1: 10,
                                                                        x2: 130, y2: 10,
                                                                        lineWidth: 0.5
                                                                    },
                                                                ]
                                                            },
                                                            {
                                                                text: '(dd/mmm/yyyy)'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        canvas: [
                                                            {
                                                                type: 'line',
                                                                x1: 0, y1: 80,
                                                                x2: 200, y2: 80,
                                                                lineWidth: 0.5
                                                            },
                                                        ]
                                                    },
                                                    {text: '', margin: [0, 2]},
                                                    {
                                                        text: 'Authorized Signatory (Company Stamp if applicable)',
                                                        fontSize: 7.5
                                                    },
                                                ]
                                            }
                                        ]
                                    ]
                                }
                            },
                        ]
                    }
                ]
            },
            break({visible = false}) {
                if (visible) {
                    return {text: '', pageBreak: 'after'};
                } else {
                    return {}
                }
            },
            simpleTable({header, body = []}) {
                let tableHeader = [];
                let tableBody = [];
                let width = [];
                let keys = Object.keys(body[0]);
                header.forEach((v) => {
                    tableHeader.push({
                        text: v.title, style: 'tHeader'
                    });
                    if (v.width) {
                        width.push(v.width);
                    } else {
                        width.push('auto');
                    }
                });

                tableBody.push(tableHeader);

                body.forEach((vv) => {
                    let body = [];
                    header.forEach((v) => {
                        keys.forEach((k) => {
                            if (k === v.key) {
                                let text = vv[k];
                                if (text) {
                                    if (v.isDate) {
                                        text = moment(vv[k]).format('DD/MMM/YYYY');
                                    } else if (v.isCurrency) {
                                        text = this.toCurrency(vv[k]);
                                    } else if (v.isPercentage) {
                                        text = vv[k] + '%';
                                    } else {
                                        text = vv[k].toString();
                                    }
                                } else {
                                    text = '';
                                }

                                body.push(
                                    {
                                        text: text, style: 'tBody'
                                    }
                                )

                            }
                        })
                    });
                    tableBody.push(body);

                });

                return {
                    width: 'auto',
                    table: {
                        headerRows: 1,
                        widths: width,
                        body: tableBody
                    }
                }
            }
        };
        Vue.prototype.$pdf = pdf;
    }

}


